import React from "react"
import { normalizePixiesetLogosUrl } from "@/utils/pixieset-urls"

function corsUrl(src: string | undefined): string | undefined {
	const normalizedSrc = normalizePixiesetLogosUrl(src)
	if (!normalizedSrc) return normalizedSrc
	try {
		const url = new URL(normalizedSrc, window.location.origin)
		if (url.origin === window.location.origin) return normalizedSrc
		url.searchParams.set("x-cors", "1")
		return url.toString()
	} catch {
		return normalizedSrc
	}
}

export const CrossOriginImage: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = ({
	src,
	...props
}) => {
	return <img aria-hidden crossOrigin="anonymous" {...props} src={corsUrl(src)} />
}
